import { Logger } from '../helpers/Logger'
import { sailTypeCoefficient } from '@/helpers/applicationHelper'

export default {
  computed: {
    user () {
      return this.$store.getters.user
    },

    isAuthorized () {
      return this.$store.getters.isAuthorized
    },

    isLoading () {
      return this.$store.getters.showPreloader
    },

    configuration () {
      return this.$store.getters.configuration
    }
  },

  methods: {
    numberToLocaleString (number) {
      number = parseFloat(number)
      return parseFloat(number?.toFixed(2)).toLocaleString('ru', {
        minimumFractionDigits: 2
      })
    },

    sailTypeCoefficient (sail_type) {
      return sailTypeCoefficient(sail_type)
    },

    showPreloader () {
      Logger.log('Showing preloader...')
      this.$store.dispatch('showPreloader')
    },

    hidePreloader () {
      Logger.log('Hiding preloader...')
      this.$store.dispatch('hidePreloader')
    },

    keydownFilter (event) {
      if (event.key.toLowerCase() !== 'delete' && event.key.toLowerCase() !== 'backspace' &&
        event.key.toLowerCase() !== 'arrowdown' && event.key.toLowerCase() !== 'arrowup' &&
        event.key.toLowerCase() !== 'arrowleft' && event.key.toLowerCase() !== 'arrowright' &&
        event.key.toLowerCase() !== 'home' && event.key.toLowerCase() !== 'end' &&
        event.key.toLowerCase() !== 'tab' && event.key.toLowerCase() !== 'enter') {
        const charTyped = event.key
        const letterRegex = /^[A-Za-zА-Яа-я0-9-]$/
        const match = charTyped.match(letterRegex)

        if (!match) {
          event.preventDefault()
        }
      }
    }
  }
}
